import CW1 from '../assets/images/thumbnails/CW1.jpg'
import CW2 from '../assets/images/thumbnails/CW2.jpg'
import CWP1 from '../assets/images/preview/CWP1.png'
import CWP2 from '../assets/images/preview/CWP2.png'
import CWLogo from '../assets/images/logo/LogoCW.png'

const CW = [
  {
    id: 1,
    section: 'CW',
    title: 'Navidad 2012',
    thumbnailUrl: CW1,
    webUrl: 'https://www.youtube.com/embed/qNTa9S6Ydlc', // Add the episode URL
    backgroundImage: CWP1,
    seriesLogo: CWLogo,
    description: 'Inicio esta nueva mini serie de animaciónes simples para entrenar mi habilidad esta... Tanpoco me pregunten cuando sale el próximo POR FAVOR, aunque estoy pensando en hacer uno de Año Nuevo, no es oficial eh, en fin, Feliz Navidad!',
  },
  {
    id: 2,
    section: 'CW',
    title: 'Año Nuevo',
    thumbnailUrl: CW2,
    webUrl: 'https://www.youtube.com/embed/nfkOdpxD_ks', // Add the episode URL
    backgroundImage: CWP2,
    seriesLogo: CWLogo,
    description: 'En Navidad y Año Nuevo (sobre todo Año Nuevo) mucha gente acostumbra disparar al cielo como si estuvieran "matando el año" PUES NO LO HAGAN! No sabes a que le caerán tus balas, puedes dañar las pertenencias de otros o hasta quitarle la vida a algúnos. Este episodio está más corto que el anterior pero solo tuve 1 semana para desarrollarlo, ojala me entiendan, Navidad y Año Nuevo son épocas muy pegadas, pero disfrutenlo :)',
  },
  ];

  export default CW;
